import CreateInvestmentError from './CreateInvestmentError';
class CodeValidationLimitReached extends CreateInvestmentError {
    constructor(options) {
        super('The investor has reach validation attempts limit', options);
    }
}
export default CodeValidationLimitReached;
